export default __webpack_public_path__ + "static/media/facebook.bc97a2bd.svg";